<template>

    <Head title="Regras de validade" />

    <div class="flex items-center justify-between">
        <h1 class="text-3xl text-gray-777 font-roboto">Validade</h1>
    
        <select-input
            v-show="selectedTab != 'tab-history'"
            v-model="selectedMonth">
                <option 
                    v-for="(month, index) in monthsOptions"
                    :key="index"
                    :value="month.value">
                        {{ month.label }} 
                </option>
        </select-input>
    </div>

    <div class="w-full mt-10">
        <tabs 
            ref="tabsRef"
            :items="tabs"
            @change-tab="handlerChangeTab">
                <template #content.tab-colected>
                    <div class="w-full gap-4 lg:flex flex-row-reverse">
                        <div class="shadow_box rounded-lg p-6 lg:w-1/2 mb-6 lg:mb-0">
                            <h2 class="text-base text-gray-777 font-bold font-roboto">Detalhes de coleta de produtos</h2>
                            
                            <bar-chart 
                                :data-options="chartData"
                                :categories="categories"
                                :yaxis="yaxis" />
                        </div>

                        <div class="shadow_box rounded-lg p-6 lg:w-1/2">
    
                            <div class="flex flex-wrap items-center justify-between gap-4">
                                <h2 class="text-base font-bold font-roboto">Detalhes de coleta de produtos</h2>
    
                                <!-- <button
                                    @click="handlerChangeTabHistoric(1)"
                                    class="block text-center w-[100px] py-3 px-4 btn-purple">
                                        Ver todos
                                </button> -->
                            </div>
    
                            <data-table
                                v-model:columns="columns" 
                                route="shelf_life_rule_dashboard/products/colected"
                                :query="getColectedProductFilter"
                                no-data-label="Nenhum produto encontrado"
                                no-result-label="Nenhum produto encontrado" 
                                class="data-table">
                            </data-table>
    
                        </div>
                    </div>

                </template>

                <template #content.tab-lost>
                    <div class="w-full gap-4 lg:flex flex-row-reverse">
                        <div class="shadow_box rounded-lg p-6 lg:w-1/2 mb-6 lg:mb-0">
                            <h2 class="text-base text-gray-777 font-bold font-roboto">Detalhes de coleta de produtos</h2>
                            
                            <bar-chart 
                                :data-options="chartLost"
                                :categories="lostCategories"
                                :horizontal="false" />
                        </div>

                        <div class="shadow_box rounded-lg p-6 lg:w-1/2">
    
                            <div class="flex flex-wrap items-center justify-between gap-4">
                                <h2 class="text-base font-bold font-roboto">Detalhes de coleta de produtos</h2>
    
                                <!-- <button
                                    @click="handlerChangeTabHistoric(0)"
                                    class="block text-center w-[100px] py-3 px-4 btn-purple">
                                        Ver todos
                                </button> -->
                            </div>
    
                            <data-table
                                v-model:columns="columns" 
                                route="shelf_life_rule_dashboard/products/lost"
                                no-data-label="Nenhum promotor encontrado"
                                no-result-label="Nenhum promotor encontrado" 
                                class="data-table">
                            </data-table>
    
                        </div>
                    </div>

                </template>


                <template #content.tab-history>
                    <historic-tab />
                </template>

        </tabs> 
    </div>

</template>

<script>


import { Link, Head } from '@inertiajs/inertia-vue3'

import Layout from '@/Shared/Layout'

import SelectInput from '@/Shared/SelectInput.vue'
import Tabs from '@/Shared/Tabs/Tabs.vue'
import DataTable from '@/Shared/DataTable'
import BarChart from '@/Shared/BarChart'

import HistoricTab from './Tabs/HistoricTab.vue'

import axios from 'axios'


const tabs = [
    {
        idTab: 'tab-colected',
        title: 'Produtos Coletados',
        content: 'colected',
    },
    {
        idTab: 'tab-lost',
        title: 'Produtos Perdidos',
        content: 'lost',
    },
    {
        idTab: 'tab-history',
        title: 'Historico',
        content: 'history',
    },
]


const categories = [
    '+120 dias',
    '120 dias',
    '60 dias',
    '30 dias',
    '15 dias',
]




export default {
    layout: Layout,

    data() {
        return {
            loadTable: true,
            selectedMonth: 0,
            monthsOptions: [],

            selectedTab: '',

            chartData: [0, 0, 0, 0, 0],
            yaxis: {
                min: 0,
                max: 8_000_000,
                tickAmount: 10_000
            },

            lostCategories: [],
            chartLost: [],

            columns: [
                {
                    uniqid: 'created_at',
                    label: 'Data da Coleta',
                    field: 'created_at',
                    visible: true,
                    sortable: true,
                    sortOrder: 'desc',
                    classes: 'px-4 py-3 border-b text-sm col-name',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => {
                        const createdAt = new Date(val)
                        return createdAt.toLocaleDateString('pt-br');
                    },
                },
                {
                    uniqid: 'market_network',
                    label: 'Rede',
                    field: 'market_network',
                    visible: true,
                    sortable: false,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm col-login',
                    headerClass: 'p-4 text-left',
                },
                {
                    uniqid: 'market',
                    label: 'Loja',
                    field: 'market_name',
                    visible: true,
                    classes: 'px-4 py-3 border-b text-sm col-email whitespace-nowrap overflow-hidden text-ellipsis',
                    headerClass: 'p-4',
                },
                {
                    uniqid: 'product',
                    label: 'Produto',
                    field: 'product_name',
                    visible: true,
                    sortable: false,
                    classes: 'px-4 py-3 border-b text-sm col-pix whitespace-nowrap overflow-hidden text-ellipsis',
                    headerClass: 'p-4',
                },
                {
                    uniqid: 'quantity',
                    label: 'Quantidade',
                    field: 'inform_quantity',
                    visible: true,
                    sortable: false,
                    sortOrder: 'asc',
                    classes: 'px-4 py-3 border-b text-sm',
                    headerClass: 'p-4 text-left',
                    format: (val, row) => row.inform_quantity ?? '0'
                },
            ],

        }
    },

    components: {
        SelectInput,
        Tabs,
        Link,
        Head,
        DataTable,
        BarChart,

        HistoricTab,
    },

    mounted() {
        this.getValidStaticsProducts()
        this.getLostStaticsProducts()

        const interatorDate = new Date()

        this.selectedMonth = interatorDate.getMonth() + 1

        interatorDate.setMonth(0)
        for (let i = 1; i < 12; i++) {
            this.monthsOptions.push({ 
                value: interatorDate.getMonth() + 1, 
                label: interatorDate.toLocaleDateString('pt-br', { month: 'long' }) 
            })

            interatorDate.setMonth(i)
        }

    },

    watch: {
        selectedMonth() {
            this.getValidStaticsProducts()
            this.getLostStaticsProducts()
        }
    },


    computed: {
        getColectedProductFilter() {
            return `month=${this.selectedMonth}`
        }
    },

    methods: {
        handlerChangeTab(event) {
            this.selectedTab = event.selectedTab
        },


        handlerChangeTabHistoric(filterBy) {
            this.selectedTab = 'tab-history'
            this.$refs.tabsRef.changeTabAmount('tab-history', 2)
        },

        async getValidStaticsProducts() {
            const query = {
                month: this.selectedMonth,
            }


            try {
                const response = await axios.get('/shelf_life_rule_dashboard/products/colected/statics', {
                    params: query,
                })

                this.chartData = Object.values(response.data.statics)
                this.yaxis = {
                    min: 0,
                    max: response.data.max,
                    tickAmount: 100
                }
            }
            
            catch {
                this.$toast.error('Ocorreu um erro ao buscar estatisticas produtos coletados')
            }
        },

        async getLostStaticsProducts() {
            const query = {
                month: this.selectedMonth,
            }


            try {
                const response = await axios.get('/shelf_life_rule_dashboard/products/lost/statics', {
                    params: query,
                })

                const values = Object.values(response.data)
                
                this.lostCategories = values.map(category => category.name)
                this.chartLost = values.map(category => category.quantity)

            }
            
            catch {
                this.$toast.error('Ocorreu um erro ao buscar estatisticas de produtos perdidos')
            }
        },
    },

    setup() {

        return { 
            tabs,
            categories,
        };
    },
}

</script>
